import { Breakpoint } from "./types";

export const BREAKPOINT_XS = 576;
export const BREAKPOINT_SM = 768;
export const BREAKPOINT_MD = 992;
export const BREAKPOINT_LG = 1200;
export const BREAKPOINT_XL = 1400;
export const BREAKPOINT_XXL = 1600;

export const BREAKPOINT_XS_MAX_WIDTH = 540;
export const BREAKPOINT_SM_MAX_WIDTH = 720;
export const BREAKPOINT_MD_MAX_WIDTH = 960;
export const BREAKPOINT_LG_MAX_WIDTH = 1140;
export const BREAKPOINT_XL_MAX_WIDTH = 1320;
export const BREAKPOINT_XXL_MAX_WIDTH = 1560;

export const BREAKPOINTS: Record<Breakpoint, number> = {
  xs: BREAKPOINT_XS,
  sm: BREAKPOINT_SM,
  md: BREAKPOINT_MD,
  lg: BREAKPOINT_LG,
  xl: BREAKPOINT_XL,
  xxl: BREAKPOINT_XXL,
};

export const BREAKPOINTS_MAX_WIDTH: Record<Breakpoint, number> = {
  xs: BREAKPOINT_XS_MAX_WIDTH,
  sm: BREAKPOINT_SM_MAX_WIDTH,
  md: BREAKPOINT_MD_MAX_WIDTH,
  lg: BREAKPOINT_LG_MAX_WIDTH,
  xl: BREAKPOINT_XL_MAX_WIDTH,
  xxl: BREAKPOINT_XXL_MAX_WIDTH,
};
